export default __webpack_public_path__ + "static/media/tensorflow.04d29a7b.svg";